export default [
    {
      path: '',
      name: 'confirmOrder',
      meta: {
        // title: '确认购买'
        title: '确认订单'
      },
      component: () => import('@/views/confirm-order/index.vue')
    },
    {
      path: 'pay-loading',
      name: 'pay-loading',
      meta: {
        title: '支付结果',
        activity: true
      },
      component: () => import('@/views/confirm-order/pay-loading/index.vue')
    },
    {
      path: 'pay-ios-bridge',
      name: 'pay-ios-bridge',
      meta: {
        title: '支付中间页',
        activity: true
      },
      component: () => import('@/views/confirm-order/pay-ios-bridge/index.vue')
    },
    {
      path: 'pay-success',
      name: 'pay-success',
      meta: {
        title: '支付结果'
      },
      component: () => import('@/views/confirm-order/pay-success/index.vue')
    },
    {
      path: 'pay-error',
      name: 'pay-error',
      meta: {
        title: '支付结果'
      },
      component: () => import('@/views/confirm-order/pay-error/index.vue')
    }
  ]
